import React from "react";
import "./Clientes.css";

// Import Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// Import das imagens dos clientes
import logoApedi from "../../assets/img/clientes/APEDI_LOGO.jpg";
import logoCivilPav from "../../assets/img/clientes/CIVIL PAV_LOGO.png";
import logoDomingao from "../../assets/img/clientes/GRUPO DOMINÇÃO_LOGOpng.png";
import logoLiraBarra from "../../assets/img/clientes/liraBarra.png";
import logoNexa from "../../assets/img/clientes/nexa.png";
import logoParaibuna from "../../assets/img/clientes/PARAIBUNA_LOGO.jpg";
import logoPedraLider from "../../assets/img/clientes/PEDRA LÍDER_LOGO.jpg";
import logoSantaMonica from "../../assets/img/clientes/PEDREIRA SANTA MONICA_LOGOjpg.jpg";
import logoSantoCristo from "../../assets/img/clientes/PEDREIRA SANTO CRISTO_LOGO.png";

export default function SecaoClientes() {
  const clientes = [
    { img: logoNexa, alt: "Nexa" },
    { img: logoDomingao, alt: "Grupo Domingão" },
    { img: logoLiraBarra, alt: "Lira Barra" },
    { img: logoSantoCristo, alt: "Pedreira Santo Cristo" },
    { img: logoCivilPav, alt: "CivilPav Pavimentações" },
    { img: logoPedraLider, alt: "Pedra Líder Pedreira" },
    { img: logoApedi, alt: "APEDI Itapiruçu" },
    { img: logoParaibuna, alt: "Paraibuna Embalagens" },
    { img: logoSantaMonica, alt: "Pedreira Santa Mônica" },
  ];

  return (
    <section className="clientes-wrapper py-5" id="clientes">
      <div className="container text-center">
        <h2 className="titulo-secao scroll-reveal-zoom">
          Clientes
          <span className="barra"></span>
        </h2>

        <p className="mb-5 scroll-reveal-zoom">
          Empresas que confiam no nosso trabalho e caminham conosco.
        </p>

        {/* CARROSSEL SWIPER */}
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          slidesPerView={2}
          breakpoints={{
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
            1200: { slidesPerView: 6 },
          }}
          className="clientes-carousel"
        >
          {clientes.map((cliente, index) => (
            <SwiperSlide key={index}>
              <div className="cliente-item scroll-reveal-zoom">
                <img
                  src={cliente.img}
                  alt={cliente.alt}
                  className="img-fluid cliente-logo"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}